<!-- =========================================================================================
    File Name: VxReadMore.vue
    Description: Read More Component
    Component Name: VxReadMore
    ----------------------------------------------------------------------------------------
    Author: Janaka Edirisinghe
========================================================================================== -->
<template>
  <span>
    {{ formatted_text || 'N/A'}} <span v-if="text.length > length && !is_on_read_more">...</span>

    <span class="text-warning cursor-pointer" v-if="text.length > length"
          @click.stop="is_on_read_more = !is_on_read_more">
      {{ is_on_read_more ? 'show less' : 'read more' }}
    </span>

  </span>
</template>

<script>
export default {
  name: "VxReadMore",
  data() {
    return {
      is_on_read_more: false
    }
  },
  props: {
    text: {
      type: String,
      default: ''
    },
    length: {
      type: Number,
      default: 50
    }
  },
  computed: {
    formatted_text: function () {
      return this.text.slice(0, this.is_on_read_more ? this.text.length : this.length)
    }
  },
}
</script>

<style scoped>

</style>
